import { Route } from '@angular/router';
const routes: Route[] = [
    {
        path: 'cargue-documentos', 
        loadComponent: () => import('./external-beneficiary-documents.component').then(m => m.ExternalBeneficiaryDocumentsComponent),
        children: [
            {
                path: "documentos",
                loadComponent: () => import("./page/external-beneficiary-documents-form/external-beneficiary-documents-form.component").then((c) => c.ExternalBeneficiaryDocumentsFormComponent)
            },
            { 
                path: 'exito',
                loadComponent: () => import('./page/success/success.component').then((c) => c.SuccessComponent)
            },
            { 
                path: 'not-found',
                loadComponent: () => import('./page/not-found/not-found.component').then((c) => c.NotFoundComponent)
            }
        ]
    }
]

export default routes;